module.exports = __webpack_public_path__ + "img/3de0ea0.png";